import { render, staticRenderFns } from "./CallTransfromLimit.vue?vue&type=template&id=1d946694&scoped=true"
import script from "./CallTransfromLimit.vue?vue&type=script&lang=js"
export * from "./CallTransfromLimit.vue?vue&type=script&lang=js"
import style0 from "./CallTransfromLimit.vue?vue&type=style&index=0&id=1d946694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d946694",
  null
  
)

export default component.exports